import { render, staticRenderFns } from "./FloorPhysicsAssociationList.vue?vue&type=template&id=245c39d3&"
import script from "./FloorPhysicsAssociationList.vue?vue&type=script&lang=js&"
export * from "./FloorPhysicsAssociationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports